import { render, staticRenderFns } from "./DeBroglieViz.vue?vue&type=template&id=5be66c56&scoped=true"
import script from "./DeBroglieViz.vue?vue&type=script&lang=js"
export * from "./DeBroglieViz.vue?vue&type=script&lang=js"
import style0 from "./DeBroglieViz.vue?vue&type=style&index=0&id=5be66c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be66c56",
  null
  
)

export default component.exports